import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table/interface';
import { ButtonPrimary } from '../../components/Button/ButtonPrimary';
import { Link } from 'react-router-dom';
import { Feature } from '../../../models/Feature/Feature';
import { FaEdit as EditIcon, FaTrash as DeleteIcon } from 'react-icons/fa';
import { useState } from 'react';
import { toast } from 'react-toastify';
import ConfirmationModal from '../../components/Modals/ConfirmationModal/ConfirmationModal';

import style from './feature-list.module.scss';

export default function FeatureList() {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [featureToDelete, setFeatureToDelete] = useState<Feature | null>(null);
  const client = useQueryClient();

  const { data: features } = useQuery(['features'], () => Feature.all());

  const handleDelete = async () => {
    if (!featureToDelete) return;

    try {
      await Feature.delete(featureToDelete.id);
      toast.success('Karakteristika uspešno obrisana!');
      client.invalidateQueries({ queryKey: ['features'] });
      setDeleteModalVisible(false);
      setFeatureToDelete(null);
    } catch (error: any) {
      toast.error(error?.response?.data?.message || 'Greška pri brisanju!');
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: 'ID',
      dataIndex: 'id'
    },
    {
      title: 'Naziv',
      dataIndex: 'name'
    },
    {
      title: 'Akcije',
      render(_, record) {
        return (
          <div className={style.actions} style={{ display: 'flex', justifyContent: 'center' }}>
            <Link to={`/admin/features/edit/${record.id}`} className='cs-edit-button'>
              <EditIcon />
            </Link>
            <button
              className='cs-delete-button'
              onClick={() => {
                setFeatureToDelete(record);
                setDeleteModalVisible(true);
              }}
            >
              <DeleteIcon />
            </button>
          </div>
        );
      }
    }
  ];

  return (
    <div className="cs-inner-container">
      <h1 className="cs-title">Lista Karakteristika</h1>
      <div className={style.info}>
        <div className={style.number}>
          Trenutno imate <span>{features?.length}</span> karakteristika
        </div>
        <ButtonPrimary url="/admin/features/create">
          Dodaj Karakteristiku
        </ButtonPrimary>
      </div>
      <Table
        columns={columns}
        dataSource={features}
        className="cs-table-wrapper"
        rowKey={'id'}
      />
     

      <ConfirmationModal
        show={deleteModalVisible}
        onCancel={() => {
          setDeleteModalVisible(false);
          setFeatureToDelete(null);
        }}
        onConfirm={handleDelete}
        title="Brisanje Karakteristike"
        message={`Da li ste sigurni da želite da obrišete karakteristiku "${featureToDelete?.name}"?`}
      />
    </div>
  );
}
